module.exports = __webpack_public_path__ + "img/3.dff7b6c.png";